module.exports = __webpack_public_path__ + "img/12_96.d9280871.png";